const tokenName = "ARMS.LastBrowserActivityDate";
const refreshInterval = 5 * 1000;
const webAppUrl = window["WEB_APP_ROOT"];
const getTimeoutUrl = `${webAppUrl}/Settings/GetBrowserInactivityTimeout`;
const quiteLogOffUrl = `${webAppUrl}/Account/QuietLogout`;

window.addEventListener("load", () => {
    if (window["IS_USER_AUTHENTICATED"]) {
        const xhr = new XMLHttpRequest();
        xhr.open("get", getTimeoutUrl);
        xhr.onload = () => {
            if (xhr.response && xhr.response > 0) {
                const userInactivityTimeout = xhr.response * 1000;

                const token = localStorage.getItem(tokenName);
                if (token) {
                    if ((new Date().getTime() - new Date(token).getTime()) > userInactivityTimeout) {
                        localStorage.removeItem(tokenName);
                        window.location.href = quiteLogOffUrl;
                        return;
                    }
                }

                (function run() {
                    localStorage.setItem(tokenName, new Date().toISOString());
                    setTimeout(run, refreshInterval);
                })();
            } else {
                localStorage.removeItem(tokenName);
            }
        };
        xhr.send();
    } else {
        localStorage.removeItem(tokenName);
    }
});
